import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

export default [
  {
    imgSrc:
      'https://www.nerdwallet.com/assets/blog/wp-content/uploads/2018/05/article_mortgage-ad7-2400x1440.jpg',
    imgAlt:
      'Woman with glasses and a cup checking her laptop while a child and a man are playing in the background',
    title: 'How to Refinance Your Mortgage',
    subtitle:
      'Mortgage refinancing lets you save money or tap equity. Set your home refinance goal, then compare rates and fees.',
    description:
      "A smart refinance strategy is crucial, whether your main goal is a lower payment, a shorter-term loan or tapping your home's equity.",
    impressionTrackingId: 'rc-related-articles-how-to',
    link: '/blog/mortgages/how-to-refinance-your-mortgage?trk_source=mortgages_rc_mustread&trk_content=blog_howtorefi+pos_topleft&trk_destination=how-to-refinance-your-mortgage&trk_origin=refinance-calculator&trk_app=blog',
  },
  {
    imgSrc: iconUri('Lightbulb'),
    imgAlt: 'Light bulb',
    title: 'How Often Can You Refinance Your Mortgage?',
    description:
      'There are lots of reasons to refinance, but are multiple refinances a good idea?',
    impressionTrackingId: 'rc-related-articles-how-often',
    link: '/blog/mortgages/how-often-can-you-refinance-your-mortgage?trk_source=mortgages_rc_mustread&trk_content=blog_howoftencanyourefi+pos_topright&trk_destination=how-often-can-you-refinance-your-mortgage&trk_origin=refinance-calculator&trk_app=blog',
  },
  {
    imgSrc: iconUri('Certificate'),
    imgAlt: 'Certificate',
    title: 'How to Refinance Your Mortgage With a Low Credit Score',
    description:
      'Even if your credit score is on the low side, there are ways you can successfully refinance.',
    impressionTrackingId: 'rc-related-articles-bad-credit',
    link: '/blog/mortgages/managing-your-mortgage/how-to-refinance-with-a-low-credit-score?trk_source=mortgages_rc_mustread&trk_content=blog_howtorefilowcredit+pos_bottomleft&trk_destination=how-to-refinance-with-a-low-credit-score&trk_origin=refinance-calculator&trk_app=blog',
  },
  {
    imgSrc: iconUri('Cash_back_3'),
    imgAlt: 'Cash Back',
    title: 'Cash-out Refinance Pros and Cons',
    description:
      "A cash-out refinance lets you tap your home's equity and turn it into cash. Is it the right move for you?",
    impressionTrackingId: 'rc-related-articles-cash-out',
    link: '/blog/mortgages/refinance-cash-out?trk_source=mortgages_rc_mustread&trk_content=blog_cashoutproscons+pos_bottomright&trk_destination=refinance-cash-out&trk_origin=refinance-calculator&trk_app=blog',
  },
];
